import React from "react";
import { LegalLayout, H2, P, UL } from "./LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout testid="terms-page" title="Terms & Conditions" lastUpdated="February 1, 2026">
      <P>
        These Terms &amp; Conditions ("Terms") govern your access to and use of the website
        simplestylemode.com (the "Site") and the purchase of any products offered on the Site
        (the "Products"). The Site is operated by <strong>ULTRANEQ LLC</strong>, a limited
        liability company registered in the United States, with its principal place of business
        at 2105 Vista Oeste NW, Albuquerque, NM 87120, United States
        ("we", "us", "our", "Seller"). By placing an order, you ("Customer", "you") agree to
        be bound by these Terms.
      </P>

      <H2>1. Identification of the Seller</H2>
      <UL>
        <li>Company: ULTRANEQ LLC (d/b/a "Simple Style Mode")</li>
        <li>Business activity: Online retail of apparel and accessories</li>
        <li>Registered address: 2105 Vista Oeste NW, Albuquerque, NM 87120, United States</li>
        <li>Customer support email: support@simplestylemode.com</li>
      </UL>

      <H2>2. Scope and acceptance</H2>
      <P>
        These Terms apply to all sales of Products made through the Site to consumers
        ("Customers"). Placing an order implies full and unreserved acceptance of these Terms.
        Simple Style Mode reserves the right to update these Terms at any time; the version in
        force at the time of order is the one applicable to that order.
      </P>

      <H2>3. Products</H2>
      <P>
        All Products sold on the Site are unbranded or sold under our own brand "Simple Style
        Mode". We do not sell replicas, counterfeit goods, or licensed third-party products.
        Product descriptions, materials, and measurements are provided in good faith; minor
        variations in colour, texture or sizing may occur due to the nature of textile
        production and screen calibration.
      </P>

      <H2>4. Prices and payment</H2>
      <UL>
        <li>Prices are displayed in US Dollars (USD) and include any applicable taxes except where noted at checkout.</li>
        <li>Shipping costs are calculated and shown at checkout before payment.</li>
        <li>Payments are processed securely by Stripe, Inc. We do not store your full card number on our servers.</li>
        <li>Accepted payment methods: Visa, Mastercard, American Express, and other methods supported by Stripe.</li>
        <li>The order is deemed confirmed only after successful payment authorisation.</li>
      </UL>

      <H2>5. Order process</H2>
      <P>
        By clicking "Place order" you submit a binding offer to purchase. You will receive an
        order confirmation by email. We reserve the right to refuse or cancel any order for
        legitimate reasons, including suspected fraud, stock unavailability, or pricing errors.
        In such case, any sums already paid will be refunded in full.
      </P>

      <H2>6. Shipping and delivery</H2>
      <UL>
        <li>Orders are processed Monday to Friday, excluding US public holidays.</li>
        <li>Orders are typically dispatched within 1–2 business days.</li>
        <li>Standard delivery: 3–7 business days (United States), 7–14 business days (international).</li>
        <li>Shipping is free on orders over $100 (subtotal). Otherwise a flat fee of $9 applies.</li>
        <li>Risk of loss or damage transfers to the Customer upon delivery.</li>
        <li>Import duties and taxes for international orders are the responsibility of the Customer.</li>
      </UL>

      <H2>7. Right of withdrawal and returns</H2>
      <P>
        Customers may return unworn, unwashed Products in their original condition and
        packaging within 30 days of delivery. Please refer to our <a href="/refund-policy" className="underline">Refund Policy</a>
        {" "}for the full procedure, timelines and customer rights.
      </P>

      <H2>8. Intellectual property</H2>
      <P>
        All content on the Site — including text, graphics, logos, images, and garment designs —
        is the property of ULTRANEQ LLC and protected by applicable intellectual property laws.
        You may not reproduce, copy, modify or commercially exploit any part of the Site
        without our prior written consent.
      </P>

      <H2>9. Liability</H2>
      <P>
        To the maximum extent permitted by law, our liability under these Terms is limited to
        the amount actually paid for the Product concerned. We are not liable for indirect,
        incidental, consequential or punitive damages. Nothing in these Terms limits your
        statutory consumer rights that cannot be excluded under applicable law.
      </P>

      <H2>10. Force majeure</H2>
      <P>
        We are not liable for any failure or delay in performance caused by events outside of
        our reasonable control, including natural disasters, pandemics, strikes, carrier
        failures, or governmental actions.
      </P>

      <H2>11. Governing law and jurisdiction</H2>
      <P>
        These Terms are governed by the laws of the State of New Mexico, United States. Any
        disputes shall be submitted to the competent courts of Bernalillo County, New Mexico,
        subject to any mandatory consumer protection provisions of the Customer's country of
        residence.
      </P>

      <H2>12. Contact</H2>
      <P>
        Any questions concerning these Terms may be addressed to{" "}
        <a href="mailto:support@simplestylemode.com" className="underline">support@simplestylemode.com</a>.
      </P>
    </LegalLayout>
  );
}
